import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'hsc-header',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: ` <bolt-header sticky="on" class="sticky top-0 z-10" /> `,
})
export class Header {}
